<template>
<keep-alive>
  <el-card shadow="never" class="aui-card--fill batch-settlement-page">
    <el-row class="page-header" style="padding-bottom: 0 !important;">
      <el-col
        :xs="24"
        :md="5"
        style="
          line-height: 40px;
          font-size: 16px;
          color: #121212;
          font-weight: bold;
        "
      >
        <img
          style="width: 16px; height: 16px; margin-right: 12px"
          src="../batch-settlement/image/批量结算申请@2x.png"
        />
        结算列表
      </el-col>
      <el-col :xs="21" :md="19" v-if="this.settlementStatus === 'enterprise'">
        <el-form :inline="true" style="text-align: right;">
          <el-form-item>
            <el-button type="info" @click="handleExport">导出</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="info" @click="handleRefresh">刷新</el-button>
          </el-form-item>
          <el-form-item v-if="headMetaIndex == 0 || headMetaIndex ==  2 || headMetaIndex == 1">
            <el-button  type="danger" @click="handleDelete">删除</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row class="page-tabs" style="padding-bottom: 0 !important;">
      <el-col
        v-if="this.settlementStatus === 'enterprise'"
        style="
          line-height: 40px;
          font-size: 16px;
          color: #121212;
          font-weight: bold;
          background: #fff;
        "
      >
        <button
          v-for="(item, index) in headMetaBtn"
          class="auxiliary-accounting-btn"
          :class="{ active: index == headMetaIndex }"
          @click="handleHeadMetaBtn(index)"
        >
          {{`${item.name ? item.name : 0}(${item.num ? item.num : 0})`}}
        </button>
      </el-col>
    </el-row>
    <div class="page-content">
      <keep-alive>
      <to-be-reviewed
        ref="toBeReviewed"
        v-if="headMetaIndex == 0 && this.settlementStatus === 'enterprise'"
      ></to-be-reviewed>
      <to-be-paid
        ref="toBePaid"
        v-else-if="headMetaIndex == 2 && this.settlementStatus === 'enterprise'"
      ></to-be-paid>
      <paid
        ref="Paid"
        v-else-if="headMetaIndex == 3 && this.settlementStatus === 'enterprise'"
      ></paid>
      <settle-all
        ref="settleAll"
        v-else-if="headMetaIndex == 4 && this.settlementStatus === 'enterprise'"
      ></settle-all>
      <PaidPard
        ref="PaidPard"
        v-else-if="headMetaIndex == 5 && this.settlementStatus === 'enterprise'"
      ></PaidPard>
      <PaidAll
        ref="PaidAll"
        v-else-if="headMetaIndex == 6 && this.settlementStatus === 'enterprise'"
      ></PaidAll>
      <PaidRejected
        ref="PaidRejected"
        v-else-if="headMetaIndex == 1 && this.settlementStatus === 'enterprise'"
      ></PaidRejected>
      </keep-alive>
      <personal-settlement v-if="this.settlementStatus === 'personal'" />
    </div>
  </el-card>
  </keep-alive>
</template>
<script>
import toBeReviewed from "./comp/to-be-reviewed.vue";
import toBePaid from "./comp/to-be-paid.vue";
import Paid from "./comp/Paid.vue";
import PaidPard from "./comp/PaidPard.vue";
import PaidAll from "./comp/PaidAll.vue";
import settleAll from "./comp/settle-all.vue";
import PaidRejected from "./comp/PaidRejected.vue";
import { addDynamicRoute } from "@/router";
import Cookies from "js-cookie";
import personalSettlement from "./content/personal-settlement.vue";
export default {
  data() {
    return {
      headMetaBtn: [
        {name:"待审核"},
        {name:"已驳回"},
        {name:"待支付"},
        {name:"已支付"},
        {name:"全部"},
        {name:"部分到账"},
        {name:"全部到账"},
      ],
      headMetaIndex: 0,
      settlement: "0",
      settlementList: [
        {
          value: "0",
          label: "企业结算列表",
        },
        {
          value: "1",
          label: "个人结算列表",
        },
      ],
      settlementStatus: "enterprise",
    };
  },
  prop: {},
  components: {
    toBeReviewed,
    toBePaid,
    Paid,
    settleAll,
    personalSettlement,
    PaidPard,
    PaidAll,
    PaidRejected
  },
  watch: {},
  computed: {},
  mounted(){
    console.log(this.$route.params)
      this.headMetaIndex = this.$route.params.activeIndex ? this.$route.params.activeIndex : (localStorage.getItem('activeIndex') || 0)
      this.getNum();
  },
  // beforeDestroy(){
  //     localStorage.removeItem('activeIndex')
  // },
  methods: {
    // 获取总条数
    async getNum(){
      const res = await this.$http.get('/sys/plat/deal/approval/getBatchSettlementCount');
      const resNum = res.data.data;
      this.headMetaBtn = [
        {name:"待审核",num:resNum.status1},
        {name:"已驳回",num:resNum.status8},
        {name:"待支付",num:resNum.status2},
        {name:"已支付",num:resNum.status3},
        {name:"全部",num:resNum.all},
        {name:"部分到账",num:resNum.status4},
        {name:"全部到账",num:resNum.status6},
      ]
      
    },
    handleHeadMetaBtn(ind) {
      let statusStr = '';
      // 获取统计金额
      if(this.headMetaIndex == 0){
        statusStr = '1'
      }else if(this.headMetaIndex == 1){
        statusStr = '8'
      }else if(this.headMetaIndex == 2){
        statusStr = '2,7'
      }else if(this.headMetaIndex == 3){
        statusStr = '3'
      }else if(this.headMetaIndex == 6){
        statusStr = '6'
      }else if(this.headMetaIndex == 5){
        statusStr = '4'
      }
     
      // this.getNum();
      localStorage.setItem('activeIndex',ind)
      this.headMetaIndex = ind;
      this.$nextTick(() => {
        this.handleRefresh();
      })
    },
    handleStatusChange(e) {
      if (e == 1) this.settlementStatus = "personal"; //个人
      if (e == 0) this.settlementStatus = "enterprise"; //企业
    },
    //批量审核
    handleBatchPayment() {},
    //批量审核
    handleBatchAudit() {},
    //导出
    handleExport() {
      //                根据headMetaIndex状态导出对应的Tap数据
      if (this.headMetaIndex == 0) {
        //待审核
        let toExamineParams = {
          form: this.$refs.toBeReviewed.form,
          pageObject: this.$refs.toBeReviewed.pageObject,
        };
        window.open(
          `${
            window.SITE_CONFIG["apiURL"]
          }/sys/plat/deal/approval/exportBatchApproval?access_token=${Cookies.get(
            "access_token"
          )}&page=${toExamineParams.pageObject.page}&limit=${
            toExamineParams.pageObject.limit
          }&taskType=${toExamineParams.form.taskType}&money1=${
            toExamineParams.form.money1
          }&money2=${toExamineParams.form.money2}&dealCode=${
            toExamineParams.form.dealCode
          }&dealBody=${toExamineParams.form.dealBody}&status=${
            toExamineParams.form.status
          }&startDate=${toExamineParams.form.startDate}&endDate=${
            toExamineParams.form.endDate
          }`
        );
      } else if (this.headMetaIndex == 2) {
        //待支付
        let toBePaidParams = {
          form: this.$refs.toBePaid.form,
          pageObject: this.$refs.toBePaid.pageObject,
        };
        window.open(
          `${
            window.SITE_CONFIG["apiURL"]
          }/sys/plat/deal/approval/exportBatchApproval?access_token=${Cookies.get(
            "access_token"
          )}&page=${toBePaidParams.pageObject.page}&limit=${
            toBePaidParams.pageObject.limit
          }&money1=${toBePaidParams.form.money1}&money2=${
            toBePaidParams.form.money2
          }&dealCode=${toBePaidParams.form.dealCode}&dealBody=${
            toBePaidParams.form.dealBody
          }&status=${toBePaidParams.form.status}&startDate=${
            toBePaidParams.form.startDate
          }&endDate=${toBePaidParams.form.endDate}`
        );
      } else if (this.headMetaIndex == 3) {
        //已支
        let PaidParams = {
          form: this.$refs.Paid.form,
          pageObject: this.$refs.Paid.pageObject,
        };
        window.open(
          `${
            window.SITE_CONFIG["apiURL"]
          }/sys/plat/deal/approval/exportBatchApproval?access_token=${Cookies.get(
            "access_token"
          )}&page=${PaidParams.pageObject.page}&limit=${
            PaidParams.pageObject.limit
          }&money1=${PaidParams.form.money1}&money2=${
            PaidParams.form.money2
          }&dealCode=${PaidParams.form.dealCode}&dealBody=${
            PaidParams.form.dealBody
          }&status=${PaidParams.form.status}&startDate=${
            PaidParams.form.startDate
          }&endDate=${PaidParams.form.endDate}&dealMonth=${
            PaidParams.form.dealMonth
          }`
        );
      } else  if (this.headMetaIndex == 4) {
        //全部
        let settleAllParams = {
          form: this.$refs.settleAll.form,
          pageObject: this.$refs.settleAll.pageObject,
        };
        window.open(
          `${
            window.SITE_CONFIG["apiURL"]
          }/sys/plat/deal/approval/exportBatchApproval?access_token=${Cookies.get(
            "access_token"
          )}&page=${settleAllParams.pageObject.page}&limit=${
            settleAllParams.pageObject.limit
          }&money1=${settleAllParams.form.money1}&money2=${
            settleAllParams.form.money2
          }&dealCode=${settleAllParams.form.dealCode}&dealBody=${
            settleAllParams.form.dealBody
          }&status=${settleAllParams.form.status}&startDate=${
            settleAllParams.form.startDate
          }&endDate=${settleAllParams.form.endDate}`
        );
      } else if (this.headMetaIndex == 5) {
        //部分到账
        let PaidPardParams = {
          form: this.$refs.PaidPard.form,
          pageObject: this.$refs.PaidPard.pageObject,
        };
        window.open(
          `${
            window.SITE_CONFIG["apiURL"]
          }/sys/plat/deal/approval/exportBatchApproval?access_token=${Cookies.get(
            "access_token"
          )}&page=${PaidPardParams.pageObject.page}&limit=${
            PaidPardParams.pageObject.limit
          }&money1=${PaidPardParams.form.money1}&money2=${
            PaidPardParams.form.money2
          }&dealCode=${PaidPardParams.form.dealCode}&dealBody=${
            PaidPardParams.form.dealBody
          }&status=${PaidPardParams.form.status}&startDate=${
            PaidPardParams.form.startDate
          }&endDate=${PaidPardParams.form.endDate}&dealMonth=${
            PaidPardParams.form.dealMonth
          }`
        );
      } else if (this.headMetaIndex == 6) {
        //全部到账
        let PaidAllParams = {
          form: this.$refs.PaidAll.form,
          pageObject: this.$refs.PaidAll.pageObject,
        };
        window.open(
          `${
            window.SITE_CONFIG["apiURL"]
          }/sys/plat/deal/approval/exportBatchApproval?access_token=${Cookies.get(
            "access_token"
          )}&page=${PaidAllParams.pageObject.page}&limit=${
            PaidAllParams.pageObject.limit
          }&money1=${PaidAllParams.form.money1}&money2=${
            PaidAllParams.form.money2
          }&dealCode=${PaidAllParams.form.dealCode}&dealBody=${
            PaidAllParams.form.dealBody
          }&status=${PaidAllParams.form.status}&startDate=${
            PaidAllParams.form.startDate
          }&endDate=${PaidAllParams.form.endDate}&dealMonth=${
            PaidAllParams.form.dealMonth
          }`
        );
      }else if (this.headMetaIndex == 1) {
        //已驳回
        let PaidRejectedParams = {
          form: this.$refs.PaidRejected.form,
          pageObject: this.$refs.PaidRejected.pageObject,
        };
        window.open(
          `${
            window.SITE_CONFIG["apiURL"]
          }/sys/plat/deal/approval/exportBatchApproval?access_token=${Cookies.get(
            "access_token"
          )}&page=${PaidRejectedParams.pageObject.page}&limit=${
            PaidRejectedParams.pageObject.limit
          }&money1=${PaidRejectedParams.form.money1}&money2=${
            PaidRejectedParams.form.money2
          }&dealCode=${PaidRejectedParams.form.dealCode}&dealBody=${
            PaidRejectedParams.form.dealBody
          }&status=${PaidRejectedParams.form.status}&startDate=${
            PaidRejectedParams.form.startDate
          }&endDate=${PaidRejectedParams.form.endDate}&dealMonth=${
            PaidRejectedParams.form.dealMonth
          }`
        )
      }
    },
    //刷新
    handleRefresh() {
      console.log(this.headMetaIndex)
      this.getNum();
      if (this.headMetaIndex == 0 && this.$refs.toBeReviewed) this.$refs.toBeReviewed.handleQuery();
      if (this.headMetaIndex == 2 && this.$refs.toBePaid) this.$refs.toBePaid.handleQuery();
      if (this.headMetaIndex == 3 && this.$refs.Paid) this.$refs.Paid.handleQuery();
      if (this.headMetaIndex == 4 && this.$refs.settleAll) this.$refs.settleAll.handleQuery();
      if (this.headMetaIndex == 5 && this.$refs.PaidPard) this.$refs.PaidPard.handleQuery();
      if (this.headMetaIndex == 6 && this.$refs.PaidAll) this.$refs.PaidAll.handleQuery();
      if (this.headMetaIndex == 1 && this.$refs.PaidRejected) this.$refs.PaidRejected.handleQuery();
    },
    //删除
    handleDelete() {
      if (this.headMetaIndex == 0 && this.$refs.toBeReviewed){
        this.deteleData(this.$refs.toBeReviewed.multipleSelection,'toBeReviewed');
      }else if (this.headMetaIndex == 1 && this.$refs.PaidRejected){
        this.deteleData(this.$refs.PaidRejected.multipleSelection,'PaidRejected');
      }else if (this.headMetaIndex == 2 && this.$refs.toBePaid){
        this.deteleData(this.$refs.toBePaid.multipleSelection,'toBePaid');
      }
    },
    deteleData(delArr,name){
      if(delArr.length <= 0){
        return this.$message({
          message: this.$t('prompt.deleteBatch'),
          type: 'warning',
          duration: 500
        })
      }
      this.$confirm(
        this.$t('prompt.info', { 'handle': this.$t('delete') }), this.$t('prompt.title'), {
          confirmButtonText: this.$t('confirm'),
          cancelButtonText: this.$t('cancel'),
          type: 'warning'
        }).then(() => {
          this.$http.delete('/sys/plat/deal/approval',{data:delArr.map((item) => item.id)}).then(({data : res}) => {
            if (res.code !== 0) {
              return this.$message.error(res.msg)
            }
            this.$message({
              message: this.$t('prompt.success'),
              type: 'success',
              duration: 500,
              onClose: () => {
                this.$refs[name].handleQuery()
              }
            })
        }).catch(() => {})
      }).catch(() => {})
    }
  },
};
</script>
<style lang="scss" scoped>
.batch-settlement-page {
  height: calc(100vh - 80px);

  ::v-deep > .el-card__body {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 10px 20px;
    overflow: hidden;
  }

  .page-header,
  .page-tabs {
    flex-shrink: 0;
  }

  .page-content {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }
}

.auxiliary-accounting-btn {
  height: 30px;
  border: 0px;
  padding: 0 10px;
  background: 0;
  &.active {
    background: white;
    height: 30px;
    color: blue;
    border-bottom: 3px solid blue !important;
  }
  // &:first-child {
  //   border-left: 1px solid #e6e6e6;
  // }
}
</style>